export const PUSH_SUBSCRIPTION_OWNER_KEY = "pushSubscriptionOwner";

export async function getActivePushSubscription() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) return null;
    return await registration.pushManager.getSubscription();
  } catch {
    return null;
  }
}
